import { render } from "./Footer.vue?vue&type=template&id=2d7434c1&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=2d7434c1&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2624693067/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7434c1"]])

export default __exports__